import { defineMessages, FormattedMessage } from 'react-intl';

const intlPrefix = 'ugc';

export const defined = defineMessages({
  header: {
    id: `${intlPrefix}.header`,
    defaultMessage: 'People and their {name}',
  },
});

export const Description = (
  <FormattedMessage
    defaultMessage='Breitling is all about casual, conscious luxury with purpose and a touch of fun—but what makes every watch a true individual is the personality you bring to it. Share how you wear your watch by tagging a wrist-shot with the hashtag {hashTag}.'
    id={`${intlPrefix}.description`}
    values={{
      hashTag: <strong>#MyBreitling</strong>,
    }}
  />
);
